import React, { useEffect, useRef, useState } from "react";
import { TextField, Typography, makeStyles } from "@material-ui/core";
import { ASSETS } from "../../../utils/config";
import { handleFileUpload } from "../../../utils/fileUpload";
import CropperProfilePhoto from "../../CropperProfilePhoto/CropperProfilePhoto";
import "../styles.css";
import { FieldArray, useFormikContext } from "formik";
import AddLinksForm from "./AddLinksForm";
import { ButtonLoader, InputErrorSpan } from "../../inputs.styled";
import { Box, Button, CircularProgress, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EmojiPicker from "emoji-picker-react";
// import { ReactComponent as EmojiIcon } from "@assets/images/emoji.svg";
import { ReactComponent as EmojiIcon } from "@assets/images/black-smiley.svg";

const InnerForm = ({
  showHeader = true,
  apiLoading,
  isEdit = false,
  onClose,
}) => {
  const {
    values,
    setFieldValue,
    errors,
    touched,
    handleBlur,
    setFieldTouched,
    dirty,
    isValid,
    handleSubmit,
    isSubmitting,
  } = useFormikContext();

  const [title, setTitle] = useState(values.business_title ?? "");
  const [websiteUrl, setWebsiteUrl] = useState(values.business_url ?? "");
  const [description, setDescription] = useState(values.description ?? "");
  const [businessEmail, setBusinessEmail] = useState(
    values.business_email ?? ""
  );
  const [businessName, setBusinessName] = useState(values.name ?? "");

  const [displayImg, setDisplayImg] = useState(values.business_image ?? "");
  const [mediaImg, setMediaImg] = useState(values.advert_image ?? "");
  const [currentImgBeingProcessed, setCurrentImgBeingProcessed] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const [descriptionWithEmoji, setDescriptionWithEmoji] = useState(
    values.description ?? ""
  );

  const emojiPickerRef = useRef(null);
  const emojiIconRef = useRef(null);

  // const handleOutsideClick = (event) => {
  //   if (
  //     (emojiPickerRef.current &&
  //       !emojiPickerRef.current.contains(event.target) &&
  //       !emojiIconRef.current) ||
  //     !emojiIconRef.current.contains(event.target)
  //   ) {
  //     setShowEmojiPicker(false);
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("mousedown", handleOutsideClick);
  //   return () => {
  //     document.removeEventListener("mousedown", handleOutsideClick);
  //   };
  // }, []);

  console.log(descriptionWithEmoji, "EEEEEEEEEE", values.description);
  const handleEmojiSelect = (emoji) => {
    setDescription((prevState) => prevState + emoji);
    setFieldValue("description", description + emoji);
  };

  const [showImageCropper, setShowImageCropper] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const mediaInputRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    file && setUploadedFile(URL.createObjectURL(file));
    file && setShowImageCropper(true);
  };

  const handleImageClick = (imgType) => {
    setCurrentImgBeingProcessed(imgType);
    fileInputRef.current.click();
    imgType === "displayImg" && setFieldTouched("business_image", true);
    imgType === "mediaImg" && setFieldTouched("advert_image", true);
  };

  const callBackImageCropped = async (imageFile) => {
    setShowImageCropper(false);
    const imgUrl = URL.createObjectURL(imageFile);

    try {
      setLoading(true);
      const { location } = await handleFileUpload(imageFile);
      if (currentImgBeingProcessed === "displayImg") {
        setDisplayImg(location);
        setFieldValue("business_image", location);
      }
      setLoading(false);
    } catch (err) {
      console.error("File upload failed:", err);
      setLoading(false);
    }
  };
  const callBackImageNotCropped = () => setShowImageCropper(false);

  const handleMediaImage = async (e) => {
    const file = e.target.files[0];
    setLoading(true);
    try {
      const { location } = await handleFileUpload(file);

      setMediaImg(location);
      setFieldValue("advert_image", location);
      setLoading(false);
    } catch (err) {
      console.error("File upload failed:", err);
      setLoading(false);
    }
  };

  const height = 40;
  return (
    <div
      style={{
        margin: "auto",
        backgroundColor: "white",
        padding: "10px",
        borderRadius: "12px",
        // paddingLeft: "15px",
      }}
    >
      {/* {showHeader ? (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            margin: "5px",
            marginLeft: "1px",
          }}
        >
          <img
            src={ASSETS.businessbox}
            alt="titleImg"
            style={{ width: "27px", height: "21px", marginRight: "5px" }}
          />
          <Typography
            variant="h6"
            style={{
              fontSize: "14px",
              fontFamily: "DM Sans",
              lineHeight: "17px",
              fontWeight: "500",
            }}
          >
            Business Box
          </Typography>
        </div>
      ) : null} */}

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          <CircularProgress size={48} style={{ color: "#123051" }} />
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h6"
              component="h2"
              sx={{
                color: "var(--Text-Blue, var(--Secondary-Blue, #123051))",
                fontFamily: "DM Sans, sans-serif",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "16.5px",
              }}
            >
              {isEdit ? "Edit" : "Create"} Business Box
            </Typography>

            <IconButton onClick={onClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </div>
          <Typography
            variant="h6"
            style={{
              marginBottom: "6px",
              fontSize: "10px",
              fontFamily: "DM Sans",
              lineHeight: "20px",
              marginTop: "20px",
            }}
          >
            Basic Information
          </Typography>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                marginBottom: "16px",
                alignItems: "center",
              }}
            >
              <input
                type="file"
                accept=".png, .jpg, .jpeg"
                onChange={handleImageChange}
                style={{ display: "none" }}
                ref={fileInputRef}
                name="imageInput"
                id="imageInput"
              />
              <input
                type="file"
                accept="image/*"
                onChange={handleMediaImage}
                style={{ display: "none" }}
                ref={mediaInputRef}
                name="imageInput"
                id="imageInput"
              />

              {showImageCropper && (
                <CropperProfilePhoto
                  ImageURL={uploadedFile}
                  callBackImageCropped={callBackImageCropped}
                  callBackImageNotCropped={callBackImageNotCropped}
                />
              )}

              {displayImg !== "" ? (
                <img
                  src={displayImg}
                  onClick={() => handleImageClick("displayImg")}
                  alt="disImg"
                  style={{
                    height: "60px",
                    width: "60px",
                    borderRadius: "30px", // Note: use "px" with borderRadius
                    border: "0.5px dashed #BBBBBB",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <div
                  onClick={() => handleImageClick("displayImg")}
                  style={{
                    height: "60px",
                    width: "60px",
                    borderRadius: "30px", // Note: use "px" with borderRadius
                    border: "0.5px dashed #BBBBBB",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={ASSETS.addLink}
                    alt="add"
                    style={{
                      height: "15px",
                      width: "15px",
                      cursor: "pointer",
                      marginBottom: "5px",
                    }}
                  />
                  <Typography
                    variant="h6"
                    style={{
                      // marginBottom: "px",
                      fontSize: "8px",
                      fontFamily: "DM Sans",
                      textAlign: "center",
                      // lineHeight: "20px",
                    }}
                  >
                    Display <br />
                    Image
                  </Typography>
                </div>
              )}
              <div>
                <Typography
                  variant="h6"
                  style={{
                    // marginBottom: "px",
                    fontSize: "8px",
                    fontFamily: "DM Sans",
                    textAlign: "center",
                    marginLeft: "10px",
                    // lineHeight: "20px",
                  }}
                >
                  Upload PNG or JPG
                </Typography>
              </div>
            </div>
            <InputErrorSpan>
              {touched.business_image && errors.business_image
                ? errors.business_image
                : ""}
            </InputErrorSpan>
          </div>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <TextField
                name="name"
                onChange={(e) => {
                  setBusinessName(e.target.value);
                  setFieldValue("name", e.target.value);
                }}
                onBlur={handleBlur}
                variant="filled"
                placeholder="Add business name (required)"
                fullWidth
                size="small"
                value={businessName}
                style={{
                  marginBottom: "2px",
                  background: "white",
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "8px",
                    height: "30px",
                    alignItems: "center",
                    // marginLeft: "5px",
                    borderRadius: "6px",
                    backgroundColor: "#F6F7F9",
                    // color: "#BBBBBB",
                    fontFamily: "DM Sans",
                  },
                  inputProps: {
                    style: {
                      fontSize: "8px",
                      paddingLeft: "9px",
                      paddingTop: "10px",
                    },
                  },
                }}
                // helperText={touched.name && errors.name ? errors.name : ""}
              />
              <InputErrorSpan>
                {touched.name && errors.name ? errors.name : ""}
              </InputErrorSpan>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <TextField
                name="business_title"
                onChange={(e) => {
                  setTitle(e.target.value);
                  setFieldValue("business_title", e.target.value);
                }}
                onBlur={handleBlur}
                variant="filled"
                placeholder="Add title"
                fullWidth
                size="small"
                value={title}
                style={{
                  marginBottom: "8px",
                  background: "white",
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "8px",
                    height: "30px",
                    alignItems: "center",
                    marginLeft: "5px",
                    borderRadius: "6px",
                    backgroundColor: "#F6F7F9",
                    // color: "#BBBBBB",
                    fontFamily: "DM Sans",
                  },
                  inputProps: {
                    style: {
                      fontSize: "8px",
                      paddingLeft: "9px",
                      paddingTop: "10px",
                    },
                  },
                }}
              />
              <InputErrorSpan>
                {touched.business_title && errors.business_title
                  ? errors.business_title
                  : ""}
              </InputErrorSpan>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <TextField
                name="business_url"
                onChange={(e) => {
                  setWebsiteUrl(e.target.value);
                  setFieldValue("business_url", e.target.value);
                }}
                onBlur={handleBlur}
                variant="filled"
                placeholder="Add website URL"
                fullWidth
                size="small"
                value={websiteUrl}
                style={{
                  marginBottom: "8px",
                  background: "white",
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "8px",
                    height: "30px",
                    alignItems: "center",
                    borderRadius: "6px",
                    backgroundColor: "#F6F7F9",
                    // color: "#BBBBBB",
                    fontFamily: "DM Sans",
                  },
                  inputProps: {
                    style: {
                      fontSize: "8px",
                      paddingLeft: "9px",
                      paddingTop: "10px",
                    },
                  },
                }}
              />
              <InputErrorSpan>
                {touched.business_url && errors.business_url
                  ? errors.business_url
                  : ""}
              </InputErrorSpan>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <TextField
                name="business_email"
                onChange={(e) => {
                  setBusinessEmail(e.target.value);
                  setFieldValue("business_email", e.target.value);
                }}
                onBlur={handleBlur}
                variant="filled"
                placeholder="Add business email"
                fullWidth
                size="small"
                value={businessEmail}
                style={{ marginBottom: "6px", background: "white" }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "8px",
                    height: "30px",
                    alignItems: "center",
                    borderRadius: "6px",
                    backgroundColor: "#F6F7F9",
                    marginLeft: "5px",
                    // color: "#BBBBBB",
                    fontFamily: "DM Sans",
                  },
                  inputProps: {
                    style: {
                      fontSize: "8px",
                      paddingLeft: "9px",
                      paddingTop: "10px",
                    },
                  },
                }}
              />
              <InputErrorSpan>
                {touched.business_email && errors.business_email
                  ? errors.business_email
                  : ""}
              </InputErrorSpan>
            </div>
          </div>
          <FieldArray
            name="business_link"
            render={(props) => {
              return <AddLinksForm {...props} />;
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
            }}
          >
            <Typography
              variant="h6"
              style={{
                marginBottom: "6px",
                fontSize: "10px",
                fontFamily: "DM Sans",
                lineHeight: "20px",
              }}
            >
              Add business media
            </Typography>
          </div>
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <div
              style={{
                height: "78px",
                borderRadius: "5px",
                border: "0.5px dashed #BBBBBB",
                marginBottom: "8px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              {mediaImg !== "" ? (
                <>
                  {/* <img
                    onClick={() => mediaInputRef.current.click()}
                    src={mediaImg}
                    alt="mediaImg"
                    style={{
                      height: "100%",
                      width: "100%",
                      cursor: "pointer",
                      objectFit: "contain",
                    }}
                  /> */}

                  <div
                    onClick={() => mediaInputRef.current.click()}
                    style={{
                      height: "100%",
                      width: "100%",
                      cursor: "pointer",
                      backgroundImage: `url(${mediaImg})`,
                      backgroundSize: "contain",
                      backgroundPosition: "center center",
                      backgroundRepeat: "no-repeat",
                    }}
                  />
                </>
              ) : (
                <>
                  <img
                    onClick={() => mediaInputRef.current.click()}
                    src={ASSETS.addLink}
                    alt="add"
                    style={{ height: "15px", width: "15px", cursor: "pointer" }}
                  />
                  <Typography
                    variant="h6"
                    style={{
                      // marginBottom: "px",
                      fontSize: "8px",
                      fontFamily: "DM Sans",
                      textAlign: "center",
                      // lineHeight: "20px",
                    }}
                  >
                    Add Media <br />
                    File
                  </Typography>
                </>
              )}
            </div>
            <InputErrorSpan>
              {touched.advert_image && errors.advert_image
                ? errors.advert_image
                : ""}
            </InputErrorSpan>
          </div>
          <div
            ref={emojiIconRef}
            style={{
              padding: "2px",
              paddingLeft: "5px",
              paddingRight: "5px",
              marginBottom: "5px",
              display: "flex",
              alignSelf: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <EmojiIcon
              onClick={() => {
                setShowEmojiPicker((prevState) => !prevState);
              }}
              style={{ height: "18px", width: "18px", cursor: "pointer" }}
            />
          </div>
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <TextField
              name="description"
              onChange={(e) => {
                setDescription(e.target.value);
                setDescriptionWithEmoji(e.target.value);
                setFieldValue("description", e.target.value);
              }}
              onBlur={handleBlur}
              variant="filled"
              placeholder="Type business description here"
              fullWidth
              size="small"
              value={description}
              multiline
              rows={3}
              style={{ marginBottom: "6px", background: "white" }}
              InputProps={{
                disableUnderline: true,
                style: {
                  fontSize: "10px",
                  height: "85px",
                  borderRadius: "6px",
                  backgroundColor: "#F6F7F9",
                  // color: "#BBBBBB",
                  fontFamily: "DM Sans",
                },
                inputProps: {
                  style: {
                    fontSize: "12px",
                    paddingLeft: "2px",
                    paddingBottom: "35px",
                  },
                  maxLength: 500,
                },
              }}
              InputLabelProps={{
                shrink: true,
                style: {
                  fontSize: "10px",
                  top: "0px",
                  left: "9px",
                },
              }}
            />
            <InputErrorSpan>
              {touched.description && errors.description
                ? errors.description
                : ""}
            </InputErrorSpan>
          </div>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <Button
              variant="contained"
              fullWidth
              sx={{
                border: "0.5px solid #123051 !important",
                borderRadius: "20px !important",
                textTransform: "capitalize !important",
                fontSize: "14px !important",
                fontFamily: "DM Sans !important",
                height: "19px !important",
                backgroundColor: "#123051 !important",
                margin: "5px !important",
                padding: "15px 0px !important",
                color: "white !important",
                "&:disabled": {
                  color: "#F2F2F2 !important",
                  backgroundColor: "#959EB3 !important",
                  border: "none !important",
                },
              }}
              disabled={isEdit ? (!dirty ? isValid : !isValid) : !isValid}
              onClick={handleSubmit}
            >
              {apiLoading && <ButtonLoader />} Save
            </Button>
          </div>{" "}
        </>
      )}
      {showEmojiPicker ? (
        <Box
          ref={emojiPickerRef}
          style={{
            position: "absolute",
            right: "-25vw",
            top: "20vh",
          }}
        >
          <EmojiPicker
            onEmojiClick={(e) => handleEmojiSelect(e.emoji)}
            theme="light"
          />
        </Box>
      ) : null}
    </div>
  );
};

export default InnerForm;
